<template>
  <div class="Tmall-moudles" v-show="list.length > 0 && platformType * 1 !== 1">
    <img src="@/assets/goods/bg1@2x.png" class="back-img" />
    <div class="card-title">
      <img src="@/assets/goods/tianmao-logo@2x.png" class="logo-img" />
      <div class="right" @click="goToUrl">
        <div class="right-text">查看全部</div>
        <van-icon name="arrow" />
      </div>
    </div>
    <div class="goods-list">
      <div class="goods-card" v-for="(item, index) in list" :key="index">
        <a :href="item.goods_link">
          <img :src="item.cover_img" class="goods-img" />
          <div class="goods-info">
            <div class="goods-name">
              {{ item.goods_title }}
            </div>
            <div class="price">
              <span class="price-common">￥</span>
              <span class="integer">{{ toInteger(item.price) }}</span>
              <span class="price-common">{{ twoFloating(item.price) }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getTbGoodsList } from "@/api/platform";
import tools from "@/common/js/tools";

export default {
  data() {
    return {
      list: [],
      platformType: 0,
    };
  },
  mounted() {
    console.log(this.platformType);
    this.platformType = tools.platformType();
    this.getTbGoodsList();
  },
  methods: {
    toInteger(num) {
      // 取整
      let toNum = "";
      toNum = parseInt(num);
      return toNum;
    },
    twoFloating(num) {
      // 获取两位小数
      return tools.twoFloating(num);
    },
    async getTbGoodsList() {
      let ret = await getTbGoodsList();
      if (ret.code * 1 === 1) {
        this.list = ret.data.list;
      }
    },
    goToUrl() {
      this.$router.push({ name: "Tmall" });
    },
  },
};
</script>

<style lang="less" scoped>
.Tmall-moudles {
  position: relative;
  background-color: #fff;
  border-radius: 13px;
  margin: 0 12px 10px 12px;
  padding: 0 0 16px 12px;
  overflow: hidden;
  .back-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 91px;
  }
}
.card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 43px;
  padding-right: 7px;
  .logo-img {
    width: 88px;
    height: auto;
    z-index: 1;
  }
  .right {
    display: flex;
    align-items: center;
    color: #9c9c9c;
    font-size: 12px;
    z-index: 1;
    .right-text {
      margin-right: 6px;
      font-size: 12px;
    }
  }
}
.goods-list {
  display: flex;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .goods-card {
    z-index: 1;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
    .goods-img {
      border-radius: 6px 6px 0 0;
      width: 98px;
      height: 98px;
    }
    .goods-info {
      padding: 6px 3px 0 3px;
      .goods-name {
        font-size: 14px;
        color: #000;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        word-break: break-all;
      }
    }
  }
}
.price {
  color: #f2433a;
  .price-common {
    font-size: 12px;
  }
  .integer {
    font-weight: 500;
    font-size: 16px;
  }
}
</style>
